import { Box, Button, Flex, Image, Typography } from "@jewlr/storybook/core"
import { Checkbox } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import React, { useState } from "react"
import styled from "styled-components"

import GreetingCardModal from "areas/cart/line-items/gift-wrap/greeting-card-modal"
import { jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"

const CardSlider = styled(Flex)`
  cursor: pointer;
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  overflow: auto hidden;
  padding-bottom: 10px;
  ${(props) => props.theme.mediaQueries.desktop`
    gap: 16px;
  `}
`
const CardItem = styled.div`
  border: 1px solid
    ${(props) => (props.selected ? props.theme.colors.selected : "transparent")};
  border-radius: 8px;
  flex: 0 0 30vw;
  padding: 10px;
  text-align: center;
  ${(props) => props.theme.mediaQueries.tablet`
    flex: 0 0 135px;
  `}
`

const GreetingCard = ({ item, selectedGreetingCard, handleGreetingCard }) => {
  const [toggleModal, setToggleModal] = useState(false)

  const [toggleGreetingCard, setToggleGreetingCard] = useState(
    !!selectedGreetingCard
  )

  const cardOptions = item.greeting_card_options
  const selectedCardOption = cardOptions.find(
    (card) => card.addon_code === selectedGreetingCard?.addon_code
  )
  const { greeting_card_properties: greetingCardProps } =
    selectedGreetingCard?.custom_properties || {}
  const cardPrice = selectedCardOption
    ? selectedCardOption.price
    : cardOptions[0]?.price

  return (
    <div>
      <Checkbox
        checked={toggleGreetingCard}
        data-cy={`cart-line-item-greeting-card-modal-${item.style_code}`}
        onChange={() => {
          if (toggleGreetingCard) {
            handleGreetingCard(null)
            setToggleGreetingCard(false)
          } else {
            handleGreetingCard(cardOptions[0])
            setToggleGreetingCard(true)
            setToggleModal(true)
          }
        }}
      >
        <Box ml="6px">
          Add A Greeting Card (
          {cardPrice > 0
            ? `+${to_currency(cardPrice, { precision: 2 })}`
            : "FREE"}
          )
        </Box>
      </Checkbox>
      <Box ml="26px">
        <Typography
          fontSize="12px"
          fontWeight="400"
          letterSpacing="-0.03em"
          lineHeight="12px"
          mb={2}
          mt={1}
        >
          Choose and {jewlr_t("terms.personalize")} your custom greeting card.
        </Typography>
        <CardSlider
          data-cy={`cart-line-item-greeting-card-${item.style_code}`}
          mb={2}
        >
          {cardOptions.map((card, i) => (
            <CardItem
              key={`greeting-card-${card.addon_code}`}
              onClick={() => {
                if (selectedGreetingCard?.addon_code !== card.addon_code) {
                  setToggleGreetingCard(true)
                  handleGreetingCard(card)
                }
                setToggleModal(true)
              }}
              selected={selectedGreetingCard?.addon_code === card.addon_code}
            >
              <Image
                alt={card.title}
                data-cy={`cart-line-item-greeting-card-${item.style_code}`}
                key={i}
                src={card.image_url}
              />
              <Typography
                fontSize="12px"
                letterSpacing="-0.03em"
                lineHeight="14px"
              >
                {card.title}
              </Typography>
              {selectedGreetingCard?.addon_code === card.addon_code &&
                greetingCardProps?.message && (
                  <Button
                    color="primary"
                    fontSize="12px"
                    lineHeight="14px"
                    underline
                    variant="text"
                  >
                    Preview
                  </Button>
                )}
            </CardItem>
          ))}
        </CardSlider>
      </Box>
      <GreetingCardModal
        greetingCardProps={greetingCardProps}
        handleGreetingCard={handleGreetingCard}
        onClose={() => setToggleModal(false)}
        selectedCardOption={selectedCardOption}
        show={toggleModal}
      />
    </div>
  )
}

GreetingCard.propTypes = {
  handleGreetingCard: PropTypes.func,
  item: PropTypes.object,
  selectedGreetingCard: PropTypes.object,
}

export default GreetingCard
